/*
 * @Description:
 * @Date: 2023-03-26 11:20:02
 */
export const route = [
  {
    path: '/digtal-storage-list',
    name: 'digtal-storage-list',
    meta: {
      title: '数字存证管理'
    },
    component: () => import('../views/digtal-storage.vue')
  }
];
